/** Cost per hour in in-game cash (e.g. 100,000) */
export const SAFEHOUSE_COST_PER_HOUR = 100_000;

/** Minimum hours to enter safehouse (1-100) */
export const SAFEHOUSE_MIN_HOURS = 1;

/** Maximum hours to enter safehouse */
export const SAFEHOUSE_MAX_HOURS = 100;

/** Base cooldown in seconds (6 hours from exit) */
export const SAFEHOUSE_BASE_COOLDOWN = 6 * 60 * 60;

/**
 * Extra cooldown per hour selected (optional).
 * e.g. 0 = fixed 6h, 60 = 6h + 1 min per hour selected
 */
export const SAFEHOUSE_COOLDOWN_PER_HOUR = 0;
